export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14521.2a5d12a6.jpg";